import { useEffect } from 'react';

import FileBrowser from "./views/FileBrowser";

import { useSelector, useDispatch } from 'react-redux'

import { selectAuthenticationState, checkAuthenticationStatus } from './lib/store/userdata.js';
import SignIn from "./views/Login";



export default function App() {
    const dispatch = useDispatch();

    const authState = useSelector(selectAuthenticationState)

    useEffect(() => {
        dispatch(checkAuthenticationStatus());
    }, [dispatch]);
    
    if (authState === 'pending') {
        console.log ('Checking Auth State')
    }
    else if (authState === 'unauthenticated') {
        return (
            <SignIn />
        );
    }
    else if (authState === 'authenticated') {
        return (
            <FileBrowser />
        )
    }
    else {
        console.error ('Unexpected authentication state: ', authState)
    }
}